import { Action } from '../action-utils/action.interface';

export interface CrudViewConfig {
  itemActions?: Action[];
}
